import { render, staticRenderFns } from "./NavTabs.vue?vue&type=template&id=195c29d4&scoped=true"
import script from "./NavTabs.vue?vue&type=script&lang=js"
export * from "./NavTabs.vue?vue&type=script&lang=js"
import style0 from "./NavTabs.vue?vue&type=style&index=0&id=195c29d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195c29d4",
  null
  
)

export default component.exports